import React from 'react';
import { WordsList } from '../components/Wordslist';

export default class WordsPage extends React.Component {

    render() {
        return (
            <>
                <WordsList />
            </>
        )
    }
}